// LivestreamDetailOnlineHeader.js
import { connect } from 'react-redux';

import { PRIVATE_LIVESTREAM_INSUFFICIENT_BALANCE_REMAINING_PRICE_MULTIPLIER } from '../RemoteConfigKeys.js';

import { ExclusivePrivateStatus } from '../resource/liveStreamConstants.js';

import LivestreamDetailOnlineHeader from '../component/LivestreamDetailOnlineHeader.jsx';

import getFormattedLiveStreamViewers from '../selector/getFormattedLiveStreamViewers.js';
import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import { getShouldUseOverlayCta } from '../selector/getLivestreamComputedData.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';

const mapStateToProps = (state, { streamId }) => {
  return {
    viewers: getFormattedLiveStreamViewers(state, streamId),
    shouldUseOverlayCta: getShouldUseOverlayCta(state, streamId),
    isExclusivePrivatePerforming:
      getLiveStreamData(state, [streamId, 'exclusivePrivate'], 'status') ===
      ExclusivePrivateStatus.PERFORMING,
    exclusivePrivateRunOutAt: getOperationData(
      state,
      ['liveStream', 'paid', streamId],
      'exclusivePrivateRunOutAt'
    ),
    remainingBalanceMultiple: getRemoteConfigData(
      state,
      PRIVATE_LIVESTREAM_INSUFFICIENT_BALANCE_REMAINING_PRICE_MULTIPLIER
    ),
    timestampOffsetSeconds: getTimestampOffset(state, Accuracy.SECOND),
  };
};

export default connect(mapStateToProps)(LivestreamDetailOnlineHeader);
